'use client';

import { c as _c } from "react/compiler-runtime";
import { LoadingButton } from '@7f-ui/components/button/loading-button';
import { InputDate } from '@7f-ui/components/form/input-date';
import { TextArea } from '@7f-ui/components/inputs_old/text-area';
import { TextField } from '@7f-ui/components/text-field/text-field';
import { useToast } from '@7f-ui/components/toast/toast-provider';
import { getGraphQLErrorCode } from '@data-access/lib/execute';
import { valibotResolver } from '@hookform/resolvers/valibot';
import { addYears } from 'date-fns';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import type { PropsWithChildren } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useGroupsContactForm } from './_hooks/use-groups-contact-form';
const FormRow = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="mb-6">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export function GroupsContactForm() {
  const $ = _c(83);
  const toast = useToast();
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Date();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const today = t0;
  const {
    validationSchema,
    initialValues,
    mapSubmission,
    sendForm,
    isSubmitting
  } = useGroupsContactForm();
  let t1;
  if ($[1] !== router || $[2] !== toast) {
    t1 = () => {
      toast({
        type: "success",
        message: "Deine Anfrage wurde erfolgreich versendet."
      });
      router.push("/angebote/individuelle-gruppenaktivitaeten/");
    };
    $[1] = router;
    $[2] = toast;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onSuccess = t1;
  let t2;
  if ($[4] !== toast) {
    t2 = error => {
      console.error(error);
      toast({
        type: "error",
        message: getGraphQLErrorCode(error) === "INVALID_EMAIL" ? "Deine E-Mail-Adresse ist ung\xFCltig. Bitte pr\xFCfe sie auf Tippfehler." : "Deine Anfrage konnte nicht versendet werden. Bitte versuche es sp\xE4ter noch einmal."
      });
    };
    $[4] = toast;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onError = t2;
  let t3;
  if ($[6] !== validationSchema) {
    t3 = valibotResolver(validationSchema);
    $[6] = validationSchema;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== initialValues || $[9] !== t3) {
    t4 = {
      defaultValues: initialValues,
      resolver: t3
    };
    $[8] = initialValues;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    register,
    handleSubmit,
    control,
    formState
  } = useForm(t4);
  let t5;
  if ($[11] !== mapSubmission || $[12] !== onError || $[13] !== onSuccess || $[14] !== sendForm) {
    t5 = data => {
      const mappedData = mapSubmission(data);
      sendForm({
        input: {
          formType: "group-form",
          contactDetails: data.contactDetails,
          title: `Gruppen-Anfrage: ${mappedData.region} / ${mappedData.date}`,
          text: [{
            label: "Region",
            text: mappedData.region
          }, {
            label: "Erwachsene / Kinder",
            text: `${mappedData.adultCount || 0} Erwachsene / ${mappedData.childrenCount || 0} Kinder`
          }, {
            label: "Datum",
            text: mappedData.date
          }, {
            label: "Nachricht",
            text: mappedData.text || ""
          }]
        }
      }, {
        onSuccess,
        onError
      });
    };
    $[11] = mapSubmission;
    $[12] = onError;
    $[13] = onSuccess;
    $[14] = sendForm;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== handleSubmit || $[17] !== t5) {
    t6 = handleSubmit(t5);
    $[16] = handleSubmit;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const onSubmit = t6;
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h1 className="mb-8 font-heading1">Sende uns eine Nachricht</h1>;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <legend className="mb-6 font-heading3">Angaben zum gewünschten Gruppenerlebnis</legend>;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== register) {
    t9 = register("region");
    $[21] = register;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const t10 = formState.errors.region?.message;
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <FormRow><TextField {...t9} label="Zielregion" required={true} error={t10} /></FormRow>;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = t13 => {
      const {
        field: t14,
        fieldState: t15
      } = t13;
      const {
        value,
        onChange
      } = t14;
      const {
        error: error_0
      } = t15;
      return <InputDate label="Wunschdatum" minDate={today} maxDate={addYears(today, 2)} required={true} error={error_0?.message} onChange={onChange} value={value} />;
    };
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== control) {
    t13 = <FormRow><Controller control={control} name="date" render={t12} /></FormRow>;
    $[27] = control;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== register) {
    t14 = register("countAdults");
    $[29] = register;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const t15 = formState.errors.countAdults?.message;
  let t16;
  if ($[31] !== t14 || $[32] !== t15) {
    t16 = <FormRow><TextField {...t14} label="Anzahl Erwachsene" type="number" required={true} error={t15} /></FormRow>;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== register) {
    t17 = register("countChildren");
    $[34] = register;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17) {
    t18 = <FormRow><TextField {...t17} name="countChildren" label="Anzahl Kinder" type="number" /></FormRow>;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== register) {
    t19 = register("message");
    $[38] = register;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t19) {
    t20 = <FormRow><TextArea {...t19} name="message" label={"Hinweise und besondere W\xFCnsche (optional)"} className="min-h-[160px]" /></FormRow>;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t11 || $[43] !== t13 || $[44] !== t16 || $[45] !== t18 || $[46] !== t20) {
    t21 = <fieldset className="mb-12">{t8}{t11}{t13}{t16}{t18}{t20}</fieldset>;
    $[42] = t11;
    $[43] = t13;
    $[44] = t16;
    $[45] = t18;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <legend className="mb-6 font-heading3">Kontaktdaten</legend>;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== register) {
    t23 = register("contactDetails.emailAddress");
    $[49] = register;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  const t24 = formState.errors.contactDetails?.emailAddress?.message;
  let t25;
  if ($[51] !== t23 || $[52] !== t24) {
    t25 = <FormRow><TextField {...t23} label="E-Mail-Adresse" type="email" required={true} error={t24} /></FormRow>;
    $[51] = t23;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== register) {
    t26 = register("contactDetails.firstName");
    $[54] = register;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  const t27 = formState.errors.contactDetails?.firstName?.message;
  let t28;
  if ($[56] !== t26 || $[57] !== t27) {
    t28 = <FormRow><TextField {...t26} label="Vorname" error={t27} /></FormRow>;
    $[56] = t26;
    $[57] = t27;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== register) {
    t29 = register("contactDetails.lastName");
    $[59] = register;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  const t30 = formState.errors.contactDetails?.lastName?.message;
  let t31;
  if ($[61] !== t29 || $[62] !== t30) {
    t31 = <FormRow><TextField {...t29} label="Nachname" error={t30} /></FormRow>;
    $[61] = t29;
    $[62] = t30;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== register) {
    t32 = register("contactDetails.phone");
    $[64] = register;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  const t33 = formState.errors.contactDetails?.phone?.message;
  let t34;
  if ($[66] !== t32 || $[67] !== t33) {
    t34 = <FormRow><TextField {...t32} label="Telefonnummer" error={t33} /></FormRow>;
    $[66] = t32;
    $[67] = t33;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t25 || $[70] !== t28 || $[71] !== t31 || $[72] !== t34) {
    t35 = <fieldset className="mb-2">{t22}{t25}{t28}{t31}{t34}</fieldset>;
    $[69] = t25;
    $[70] = t28;
    $[71] = t31;
    $[72] = t34;
    $[73] = t35;
  } else {
    t35 = $[73];
  }
  let t36;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <p className="font-body-small text-primary opacity-30">*Pflichtfeld</p>;
    $[74] = t36;
  } else {
    t36 = $[74];
  }
  let t37;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <p className="mt-8 mb-4 font-body-small">{"Wir verarbeiten deine Daten gem\xE4\xDF unserer "}<Link href="/datenschutz" className="underline underline-offset-2" target="_blank">Datenschutzerklärung</Link>.</p>;
    $[75] = t37;
  } else {
    t37 = $[75];
  }
  let t38;
  if ($[76] !== isSubmitting) {
    t38 = <LoadingButton isLoading={isSubmitting} type="submit">Abschicken</LoadingButton>;
    $[76] = isSubmitting;
    $[77] = t38;
  } else {
    t38 = $[77];
  }
  let t39;
  if ($[78] !== onSubmit || $[79] !== t21 || $[80] !== t35 || $[81] !== t38) {
    t39 = <>{t7}<form id="group-contact-form" className="mb-10 sm:mb-8" noValidate={true} onSubmit={onSubmit}>{t21}{t35}{t36}{t37}{t38}</form></>;
    $[78] = onSubmit;
    $[79] = t21;
    $[80] = t35;
    $[81] = t38;
    $[82] = t39;
  } else {
    t39 = $[82];
  }
  return t39;
}